import { hustlingConstants } from '../../_constants';

export function hustling(state = {}, action) {
    switch (action.type) {
        case hustlingConstants.RESET:
            return {}
        case hustlingConstants.HUSTLING_FETCHING:
            return {
                ...state,
                HustlingFetching: true
            };
        case hustlingConstants.HUSTLING_FETCHED:
            return {
                ...state,
                HustlingFetching: false
            };
        case hustlingConstants.HUSTLING_SUBMITTING:
            return {
                ...state,
                HustlingSubmitting: true
            };
        case hustlingConstants.HUSTLING_SUBMITTED:
            return {
                ...state,
                HustlingSubmitting: false
            };
        case hustlingConstants.LOAD_HUSTLING: {
            return {
                ...state,
                hustlingData: action.hustlingData
            }
        }
        case hustlingConstants.GET_HUSTLING_BY_CODE: {
            return {
                ...state,
                hustlingByCode: action.hustlingByCode
            }
        }
        case hustlingConstants.VOYAGE_HUSTLING_LIST:
            return {
                ...state,
                voyageHustlingList: action.voyageHustlingList
            }
        case hustlingConstants.LOAD_VOYAGE_HUSTLING:
            return {
                ...state,
                voyageHustlingData: action.voyageHustlingData
            }
        default:
            return state;
    }
}